module.exports = __webpack_public_path__ + "img/IMG_2493_L_Foamcore_MockedUp.fbdee137.jpg";